var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100vh"},attrs:{"id":"app"}},[_c('Painel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }